import React, { useState } from "react";
import * as Icons from "assets/icons";
import { useNavigate, useLocation } from "react-router";
import { AsidebarStore } from "(store)/AsidebarStore";
import { LogoRent, LogoRentWhite, Logo } from "assets/svg";
import { AnimatePresence, motion } from "framer-motion";

const activeTab = "bg-[#e3eefb] rounded-lg dark:text-black";
const inActiveTab = "hover:bg-[#f1f7fe] hover:rounded-lg dark:hover:text-black";

const SideBar = ({ setIsOpenReview }) => {
  const [isOpen, setIsOpen] = useState(true);
  const { isSideBarOpen, setIsSideBarOpen, sideBarOptions, chatCount } = AsidebarStore();
  const navigate = useNavigate();
  const location = useLocation();

  const hanldeSideBar = () => {
    setIsOpen(!isOpen);
  };
  

  // Get the current path to determine active tab
  const currentPath = location.pathname;

  // Handle navigate page
  const handleNavigate = (path) => {
    navigate(path);
  };

  return (
    <>
      {/* Desktop Aside bar */}
      <div
        className={`${
          isOpen
            ? "w-[19em] transition-all duration-300 ease-in-out"
            : "w-[7em] transition-all duration-300 ease-in-out "
        } h-full bg-white dark:bg-[#181818] hidden lg:flex flex-col border-r dark:border-gray-800 z-20`}
      >
        {/* Logo with bottom line */}
        <div className="relative w-full h-20 flex flex-col items-center">
          {isOpen ? (
            <div className="w-full h-full hidden transition-all duration-300 ease-in-out lg:flex justify-center items-center">
              <div className="flex dark:hidden">
                <LogoRent width={"8em"} onClick={() => navigate("/")} />
              </div>
              <div className="hidden dark:flex">
                <LogoRentWhite width={"8em"} onClick={() => navigate("/")} />
              </div>
            </div>
          ) : (
            <div className="w-full h-full hidden lg:flex justify-center items-center transition-all duration-300 ease-in-out ">
              <Logo width={"2em"} onClick={() => navigate("/")} />
            </div>
          )}
          <hr className="w-[70%]" />

          {/* Side button */}
          <div
            className="absolute -right-4 top-6 rounded-full bg-alpha w-8 h-8 flex justify-center items-center text-white cursor-pointer shadow-md"
            onClick={hanldeSideBar}
          >
            {isOpen ? (
              <Icons.ChevronLeft color="white" />
            ) : (
              <Icons.ChevronRight color="white" />
            )}
          </div>
        </div>

        {/* Main Content */}
        <div className="w-full h-[calc(100%-80px)] flex flex-col items-center justify-between">
          <div className="h-[calc(100%-60px)] pt-8 w-[85%] flex justify-center">
            <ul className="font-medium px-2 w-96 flex flex-col gap-1 overflow-x-hidden no-scrollbar">
              {sideBarOptions?.map((option, index) => (
                <React.Fragment key={option.id}>
                  <li
                    onClick={() => handleNavigate(option.path)}
                    className={`group flex w-full cursor-pointer ${
                      option?.path === currentPath ? activeTab : inActiveTab
                    } ${
                      isOpen
                        ? "py-2 pl-5 justify-between"
                        : "p-2 justify-center"
                    }`}
                  >
                    <div className="flex items-center">
                      {option.icon}
                      {isOpen && <span className="pl-5">{option.title}</span>}
                    </div>
                    {option?.chat &&
                      (isOpen ? (
                        <div className="w-4 h-4 flex items-center self-center">
                          <div className="indicator">
                            <span
                              className={`indicator-item badge bg-secondary text-white group-hover:bg-white group-hover:text-black`}
                            >
                              {chatCount}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="flex self-start">
                          <div className="indicator">
                            <span
                              className={`indicator-item badge w-1 text-white bg-secondary group-hover:bg-white group-hover:text-black`}
                            >
                              {chatCount}
                            </span>
                          </div>
                        </div>
                      ))}
                  </li>
                </React.Fragment>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Mobile Aside bar */}
      <AnimatePresence>
        {isSideBarOpen && (
          <motion.div
            onClick={() => setIsSideBarOpen(false)}
            className="fixed inset-0 flex bg-black dark:bg-[#1467B0B5] justify-start bg-opacity-50 z-50"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
          >
            <motion.div
              className="absolute left-0 top-0 w-[25em] h-full bg-white dark:bg-[#181818] lg:hidden flex-col border-r dark:border-gray-800 z-50"
              initial={{ x: "-100%" }}
              animate={{ x: "0%" }}
              exit={{ x: "-100%" }}
              transition={{
                type: "just",
                stiffness: 300,
                damping: 20,
                duration: 0.3,
              }}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              {/* Logo with bottom line */}
              <div className="relative w-full h-20 flex flex-col items-center">
                <div className="w-full h-full flex justify-center items-center">
                  <div className="flex dark:hidden">
                    <LogoRent width={"8em"} onClick={() => navigate("/")} />
                  </div>
                  <div className="hidden dark:flex">
                    <LogoRentWhite
                      width={"8em"}
                      onClick={() => navigate("/")}
                    />
                  </div>
                </div>
                <hr className="w-[70%]" />
              </div>

              {/* Main Content */}
              <div className="w-full h-[calc(100%-80px)] flex flex-col items-center justify-between">
                <div className="h-[calc(100%-60px)] pt-8 w-[85%] flex justify-center">
                  <ul className="font-medium px-2 w-96 flex flex-col gap-1 overflow-x-hidden no-scrollbar">
                    {sideBarOptions?.map((option, index) => (
                      <React.Fragment key={option.id}>
                        <li
                          onClick={() => {
                                  handleNavigate(option.path);
                                  setIsSideBarOpen(false);
                                }}
                          className={`group flex w-full cursor-pointer ${
                            option?.path === currentPath
                              ? activeTab
                              : inActiveTab
                          } py-2 pl-5 justify-between`}
                        >
                          <div className="flex items-center">
                            {option.icon}
                            <span className="pl-5">{option.title}</span>
                          </div>
                          {option?.subOptions && isOpen && (
                            <span
                              className={`ml-2 ${
                                option?.isOpen ? "rotate-90" : ""
                              }`}
                            >
                              <div className="w-4 h-4">
                                <Icons.SmallArrowRightIcon />
                              </div>
                            </span>
                          )}

                          {option?.chat && (
                            <div className="w-4 h-4 flex items-center self-center">
                              <div className="indicator">
                                <span
                                  className={`indicator-item badge bg-secondary text-white group-hover:bg-white group-hover:text-black`}
                                >
                                  {chatCount}
                                </span>
                              </div>
                            </div>
                          )}
                        </li>
                        {isOpen && (
                          <div
                            className={`transition-all duration-500 ease-in-out overflow-hidden ${
                              option?.isOpen
                                ? "max-h-96 opacity-100"
                                : "max-h-0 opacity-0"
                            }`}
                          >
                            <ul className="font-normal pl-5">
                              {option?.subOptions?.map((subOption) => (
                                <li
                                  key={subOption.id}
                                  onClick={() => navigate(subOption?.path)}
                                  className={`py-2 px-8 cursor-pointer ${
                                    currentPath === subOption?.path
                                      ? "text-[#3373fc]"
                                      : "hover:text-[#142bb0]"
                                  }`}
                                >
                                  {subOption.title}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </React.Fragment>
                    ))}
                  </ul>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default SideBar;
